import {
  SIGNUP_COMPLETE,
  SET_NAME,
  SET_USERNAME,
  FETCH_USERNAME_START,
  FETCH_USERNAME_COMPLETE,
  FETCH_USERNAME_ERROR,
  UPLOAD_STARTED,
  UPLOAD_PROGRESS,
  UPLOAD_COMPLETE,
  UPLOAD_FAIL,
  GET_PHOTO_SUCCESS,
  GET_PHOTO_PENDING,
  GET_MEDITATIONS,
  USER_PHOTO_SAVED,
  AVATAR_SAVE_START,
  AVATAR_SAVE_COMPLETE,
  AVATAR_SAVE_FAIL,
  USER_DETAIL_SAVE_START,
  USER_DETAIL_SAVE_SUCCESS,
  USER_DETAIL_SAVE_ERROR,
  FETCH_USER_START,
  FETCH_USER_COMPLETE,
  FETCH_USER_ERROR,
  SAVE_LINK_START,
  SAVE_LINK_COMPLETE,
  SAVE_LINK_ERROR,
  UPDATE_LINK_START,
  UPDATE_LINK_COMPLETE,
  UPDATE_LINK_ERROR,
  DELETE_LINK_START,
  DELETE_LINK_COMPLETE,
  DELETE_LINK_ERROR,
  SET_USER_STATUS,
  USERNAME_EXISTS_ERROR,
  AUTH_USER,
  AUTH_ERROR,
} from 'constants/types';

const initialState = {
  userId: null,
  userAuthError: '',
  name: '',
  username: '',
  email: '',
  usernameExists: false,
  isFetchingUser: false,
  fetchUserError: false,
  photoBeingUploaded: false,
  photoUploadError: false,
  photoUploadProgress: 0,
  photoRef: localStorage.getItem('photoRef') || null,
  userPhoto: null,
  meditations: null,
  photoFetchPending: false,
  avatarSaveStart: false,
  avatarSaveFail: false,
  userDetailSaveStart: false,
  userDetailSaveError: false,
  userFetchError: '',
  linkActionStart: false,
  linkActionComplete: false,
  linkActionError: '',
  deleteLinkStart: false,
  savedLinks: [],
  fetchLinksStart: false,
  fetchLinksError: false,
  showTooltip: false,
  isOwner: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case AUTH_USER: {
      return {
        ...state,
        userAuthError: false,
        userId: action.payload.uid,
      }
    }
    case AUTH_ERROR: {
      return {
        ...state,
        userAuthError: true,
      }
    }
    case FETCH_USERNAME_START: {
      return {
        ...state,
        isFetchingUser: true,
        fetchUserError: false,
      }
    }
    case FETCH_USERNAME_COMPLETE: {
      return {
        ...state,
        isFetchingUser: false,
        fetchUserError: false,
        username: action.payload,
      }
    }
    case FETCH_USERNAME_ERROR: {
      return {
        ...state,
        isFetchingUser: false,
        fetchUserError: true,
      }
    }
    case SET_USER_STATUS: {
      return {
        ...state,
        isOwner: action.payload,
      }
    }
    case DELETE_LINK_START: {
      return {
        ...state,
        deleteLinkStart: true,
        linkActionComplete: false,
      }
    }
    case DELETE_LINK_COMPLETE: {
      const filteredLinks = state.savedLinks.filter(link => {
        return link.id !== action.payload;
      });

      return {
        ...state,
        linkActionStart: false,
        linkActionComplete: true,
        deleteLinkStart: false,
        savedLinks: filteredLinks,
      }
    }
    case DELETE_LINK_ERROR: {
      return {
        ...state,
        linkActionStart: false,
        linkActionComplete: true,
        linkActionError: 'Something went wrong, please try again',
      }
    }
    case UPDATE_LINK_START: {
      return {
        ...state,
        linkActionStart: true,
        linkActionComplete: false,
      }
    }
    case UPDATE_LINK_COMPLETE: {
      const filteredLinks = state.savedLinks.filter(link => {
        return link.id !== action.payload.id;
      });
      const updatedLinks = [...filteredLinks, action.payload];

      return {
        ...state,
        linkActionStart: false,
        linkActionComplete: true,
        savedLinks: updatedLinks,
      }
    }
    case UPDATE_LINK_ERROR: {
      return {
        linkActionStart: false,
        linkActionComplete: true,
        linkActionError: 'Something went wrong, please try again',
      }
    }
    case SAVE_LINK_START: {
      return {
        ...state,
        linkActionStart: true,
        linkActionComplete: false,
      }
    }
    case SAVE_LINK_COMPLETE: {
      return {
        ...state,
        linkActionStart: false,
        linkActionComplete: true,
        savedLinks: [...state.savedLinks, action.payload],
        showTooltip: false,
      }
    }
    case SAVE_LINK_ERROR: {
      return {
        ...state,
        linkActionStart: false,
        linkActionComplete: true,
        linkActionError: 'Something went wrong, please try again',
      }
    }
    case SIGNUP_COMPLETE: {
      return {
        ...state,
        userId: action.payload,
      }
    }
    case SET_NAME: {
      return {
        ...state,
        name: action.payload,
      }
    }
    case SET_USERNAME: {
      return {
        ...state,
        username: action.payload,
      }
    }
    case UPLOAD_STARTED: {
      return {
        ...state,
        photoUploadError: false,
        photoBeingUploaded: true,
      }
    }
    case UPLOAD_PROGRESS: {
      return {
        ...state,
        photoUploadProgress: action.payload,
      }
    }
    case UPLOAD_COMPLETE: {
      return {
        ...state,
        photoUploadError: false,
        photoBeingUploaded: false,
        photoRef: action.payload,
      }
    }
    case UPLOAD_FAIL: {
      return {
        ...state,
        photoUploadError: true,
        photoBeingUploaded: false,
      }
    }
    case GET_PHOTO_SUCCESS: {
      return {
        ...state,
        userPhoto: action.payload,
        photoFetchPending: false,
      }
    }
    case GET_PHOTO_PENDING: {
      return {
        ...state,
        photoFetchPending: true,
      }

    }
    case GET_MEDITATIONS: {
      const meditations = action.payload.docs.map(meditation => {
        return meditation.data();
      });

      return {
        ...state,
        meditations,
      }
    }
    case AVATAR_SAVE_START: {
      return {
        ...state,
        avatarSaveStart: true,
        avatarSaveFail: false,
      }
    }
    case AVATAR_SAVE_COMPLETE: {
      return {
        ...state,
        avatarSaveStart: false,
        avatarSaveFail: false,
      }
    }
    case AVATAR_SAVE_FAIL: {
      return {
        ...state,
        avatarSaveStart: false,
        avatarSaveFail: true,
      }
    }
    case USER_PHOTO_SAVED: {
      return {
        ...state,
        photoRef: action.payload,
      }
    }
    case USERNAME_EXISTS_ERROR: {
      return {
        ...state,
        usernameExists: true,
        userDetailSaveStart: false,
      }
    }
    case USER_DETAIL_SAVE_START: {
      return {
        ...state,
        usernameExists: false,
        userDetailSaveStart: true,
        userDetailSaveError: false,
      }
    }
    case USER_DETAIL_SAVE_SUCCESS: {
      return {
        ...state,
        userDetailSaveStart: false,
        userDetailSaveError: false,
      }
    }
    case USER_DETAIL_SAVE_ERROR: {
      return {
        ...state,
        userDetailSaveStart: false,
        userDetailSaveError: true,
      }
    }
    case FETCH_USER_START: {
      return {
        ...state,
        isFetchingUser: true,
      }
    }
    case FETCH_USER_COMPLETE: {
      const links = action.payload.links;
      const hasLinks = Boolean(links.length);

      return {
        ...state,
        isFetchingUser: false,
        name: action.payload.name,
        email: action.payload.email,
        userPhoto: action.payload.photoURL,
        username: action.payload.username,
        savedLinks: action.payload.links,
        showTooltip: !hasLinks,
      }
    }
    case FETCH_USER_ERROR: {
      return {
        ...state,
        isFetchingUser: false,
        userFetchError: 'Something went wrong, please refresh page',
      }
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/user.js